import LowerContent from './LowerContent';
export default LowerContent;
